import React from 'react';
import { Building2, Mail, Phone, Instagram, Facebook, Linkedin, Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-300 pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          <div>
            <div className="flex items-center mb-4">
              <Building2 className="h-8 w-8 text-blue-400 mr-2" />
              <span className="font-bold text-xl text-white">ImóvelIA</span>
            </div>
            <p className="mb-6">
              Transformando a maneira como investidores analisam oportunidades em leilões de imóveis com inteligência artificial.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.instagram.com/imoveisquegeramrenda/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-slate-300 hover:text-white transition-colors"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a 
                href="https://www.youtube.com/@Imoveisquegeramrenda" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-slate-300 hover:text-white transition-colors"
              >
                <Youtube className="h-5 w-5" />
              </a>
              <a 
                href="https://www.linkedin.com/in/douglas-ferreira-1a99381b1/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-slate-300 hover:text-white transition-colors"
              >
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="font-semibold text-lg text-white mb-4">Empresa</h3>
            <ul className="space-y-3">
              <li><a href="#" className="hover:text-white transition-colors">Sobre nós</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Nosso time</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Carreiras</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Blog</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold text-lg text-white mb-4">Produto</h3>
            <ul className="space-y-3">
              <li><a href="#recursos" className="hover:text-white transition-colors">Recursos</a></li>
              <li><a href="#precos" className="hover:text-white transition-colors">Preços</a></li>
              <li><a href="#faq" className="hover:text-white transition-colors">FAQ</a></li>
              <li><a href="/blog" className="hover:text-white transition-colors">Blog</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold text-lg text-white mb-4">Contato</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <Mail className="h-5 w-5 mr-2 mt-0.5" />
                <span>minasdouglas@yahoo.com.br</span>
              </li>
              <li className="flex items-start">
                <Phone className="h-5 w-5 mr-2 mt-0.5" />
                <span>(16) 99963-1188</span>
              </li>
              <li>
                <a 
                  href="https://www.tiktok.com/@imoveisquegeramrenda" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="hover:text-white transition-colors flex items-center"
                >
                  <span className="font-medium">TikTok:</span>
                  <span className="ml-1">@imoveisquegeramrenda</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="pt-8 border-t border-slate-800">
          <div className="text-center mb-6">
            <p className="text-slate-400 text-sm max-w-2xl mx-auto">
              "ImóvelIA é um assistente de análise. Não substitui assessoria jurídica/cartorial. As estimativas são informativas."
            </p>
          </div>
          
          <div className="text-center md:flex md:justify-between md:items-center">
            <p>© 2025 ImóvelIA. Todos os direitos reservados.</p>
            <div className="mt-4 md:mt-0 space-x-6">
              <a href="#" className="hover:text-white transition-colors">Termos de Serviço</a>
              <a href="#" className="hover:text-white transition-colors">Política de Privacidade</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;